module.exports = __webpack_public_path__ + "img/崇芳.png";